import React from 'react'
import { Image, Divider, Container, Button, Grid, Header, List, Segment } from 'semantic-ui-react'
import { Link } from 'react-router-dom'

import { CustomMessage, Navbar } from 'components'
import 'styling/semantic.less'

import ImageGallery from 'react-image-gallery';
import ResponsiveEmbed from 'react-responsive-embed';


const openmm8Images = [
  {
    original: './assets/openmm8/screenshot_1.png',
    thumbnail: './assets/openmm8/screenshot_1_tn.jpg',
  },
  {
    original: './assets/openmm8/screenshot_2.png',
    thumbnail: './assets/openmm8/screenshot_2_tn.jpg',
  },
  {
    original: './assets/openmm8/screenshot_3.png',
    thumbnail: './assets/openmm8/screenshot_3_tn.jpg',
  },
  {
    original: './assets/openmm8/screenshot_4.png',
    thumbnail: './assets/openmm8/screenshot_4_tn.jpg',
  },
  {
    original: './assets/openmm8/screenshot_5.png',
    thumbnail: './assets/openmm8/screenshot_5_tn.jpg',
  },
  {
    original: './assets/openmm8/screenshot_6.png',
    thumbnail: './assets/openmm8/screenshot_6_tn.jpg',
  },
  {
    original: './assets/openmm8/screenshot_7.png',
    thumbnail: './assets/openmm8/screenshot_7_tn.jpg',
  },
  {
    original: './assets/openmm8/screenshot_8.png',
    thumbnail: './assets/openmm8/screenshot_8_tn.jpg',
  },
  {
    original: './assets/openmm8/screenshot_9.png',
    thumbnail: './assets/openmm8/screenshot_9_tn.jpg',
  },
]

class OpenMM8 extends React.Component {
    
  render() {
    return (
        <Segment padded='very'>
          <Image src="./assets/openmm8/mm8.png" size='large' centered />
          <Header as='h1'>OpenMM8</Header>
          <p style={{fontSize: 16}}>
            <ul style={{lineHeight: 2}}>
              <li>Open source reimplementation of Might and Magic VIII (2001) RPG in Unity (C#)</li>
              <li>Work in progress</li>
            </ul>
          </p>

          <Divider section/>

          <Header as='h2'>Technology</Header>
          <p style={{fontSize: 16}}>
            <ul style={{lineHeight: 2}}>
              <li><b>Languages</b>: <b>C#</b></li>
              <li><b>Tools:</b>: Unity 2017, MS Visual Studio 2017</li>
              <li><b>Versioning</b>: Git</li>
            </ul>
          </p>

          <Header as='h2'>Skills</Header>
          <p style={{fontSize: 16}}>
            <ul style={{lineHeight: 2}}>
              <li>Development in existing game engine</li>
              <li>Implementation of big variety RPG features: (UI, NPC AI, Skill/Stat/Loot/Faction/Quest/Inventory/Combat/... systems)</li>
              <li>Making 2D sprites behave as 3D models in 3D world</li>
              <li>Profiling and optimizations of performance critical parts of game</li>
            </ul>
            
          </p>

          <Divider section/>

          <Header as='h2'>In-game screenshots</Header>
          <div>
            <ImageGallery items={openmm8Images} 
            infinite={true} 
            showPlayButton={false} 
            showFullscreenButton={true} 
            lazyLoad={true}
            />
          </div>

          <Divider section/>

          <Header as='h2'>OpenMM8 Video - WIP</Header>
          <ResponsiveEmbed src='https://www.youtube.com/embed/WsVgYt-NhpU' ratio='16:9' />

        </Segment>
    )
  }
}

export default OpenMM8



// WEBPACK FOOTER //
// ./src/OpenMM8.js